import React from "react";
import PropTypes from "prop-types";

import { Box, Paper, Slide, makeStyles } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import { SHOW_DATE_FORMAT } from "../../../lib/data";
import clientConfig from "../../../config/client";

const useStyles = makeStyles(() => ({
    slider: {
        position: "fixed",
        top: "10%",
        right: 0,
    },
    infoWrapper: {
        padding: ".5rem",
        "&:hover": {
            cursor: "pointer",
        },
    },
    closeIcon: {
        display: "inline-block",
        marginRight: ".5rem",
        verticalAlign: "center",
        "&:hover": {
            color: red[700],
        },
    },
}));

const locale = clientConfig.locale;
const INFO_LABELS = {
    infoLine: {
        ru: "Скопирована стоимость даты: ",
        en: "Copied prices of date: ",
    },
    closeIconTitle: {
        ru: "Закрыть",
        en: "Close",
    },
};

const CopiedColInfoModule = (props) => {
    const classes = useStyles();

    const closeHandler = () => {
        props.openHandler((prevState) => ({ ...prevState, open: false }));
    };

    return (
        <Slide
            className={classes.slider}
            direction="left"
            in={props.data.open}
            mountOnEnter
            unmountOnExit
            timeout={{ exit: 100, enter: 300, appear: 100 }}
        >
            <Paper elevation={4} onClick={closeHandler}>
                <Box className={classes.infoWrapper}>
                    <Box
                        className={classes.closeIcon}
                        title={INFO_LABELS.closeIconTitle[locale]}
                    >
                        &#215;
                    </Box>
                    <Box display="inline-block">
                        {props.data.date &&
                            INFO_LABELS.infoLine[locale] +
                                props.data.date.format(SHOW_DATE_FORMAT)}
                    </Box>
                </Box>
            </Paper>
        </Slide>
    );
};

CopiedColInfoModule.propTypes = {
    data: PropTypes.object,
    openHandler: PropTypes.func,
};

export default CopiedColInfoModule;
